// extracted by mini-css-extract-plugin
export default {"diceAnimation":"styles_diceAnimation__ktVnI","rotate":"styles_rotate__Lhw9a"};